import {ReactComponent as SectionLogo} from '../assets/academy.svg';
import { useMediaQuery } from '@mui/material';

import { motion } from 'framer-motion';

export default function Section4() {
    const isMobile = useMediaQuery("(max-width:768px)");
    return (
        isMobile ?
        <div className='w-full  bg-orange-50 mt-[20vh] py-[11.13vh] px-4 flex flex-col gap-8'>
            <h4 className='font-bold text-stone-700 xs:text-[1.5rem] s:text-[1.75rem]'>Innovate to Modernize.</h4>
            <p className='font-medium text-stone-600  xs:text-[1rem] text-[1.25rem]'>
            <strong>Bridge Academy</strong> helps organization <strong> IT leaders</strong> and <strong>  DevOps teams </strong> to improve their expertise and skills by learning innovative technologies for the purpose to expedite the application <strong>  modernization process</strong> and <strong> development model.</strong>
            </p>
            
        </div>
        :

        <motion.div className='w-full h-[47vh] mb-[23.70vh] bg-orange-50 flex justify-between items-center relative px-[10vw] '>
            <div className='flex flex-col gap-[5.926vh]'>
            <motion.h4 viewport={{ once: true }}  initial={{opacity:0,x:-50}} whileInView={{opacity:1,x:0}} transition={{type:"spring",duration:1 , delay:0.5 ,ease : 'easeOut'}} className='font-bold text-[2.1875vw] text-stone-700'>Innovate to Modernize.</motion.h4>
            <motion.div viewport={{ once: true }} initial={{opacity:0,x:-50}} whileInView={{opacity:1,x:0}} transition={{type:"spring",duration:1 , delay:0.5,ease : 'easeOut'}} className='font-medium text-[1.146vw] text-stone-600 max-w-[56.14vw]'>
            <strong>Bridge Academy</strong> helps organization <strong> IT leaders</strong> and <strong>  DevOps teams </strong> to improve their expertise and skills by learning innovative technologies for the purpose to expedite the application <strong>  modernization process</strong> and <strong> development model.</strong>

            </motion.div>
            </div>
            <motion.div viewport={{ once: true }}  initial={{opacity:0,x:50}} whileInView={{opacity:1,x:0}} transition={{type:"spring",duration:1 , delay:0.5 ,ease : 'easeOut'}} className='w-fit h-fit'>
            <SectionLogo  className='w-[16.666vw]' ></SectionLogo>
            </motion.div>
        </motion.div>
    )
}